import { render } from "./NarrationMessage.vue?vue&type=template&id=c2575ef0&scoped=true&bindings={\"narration\":\"props\",\"show\":\"options\"}"
import script from "./NarrationMessage.vue?vue&type=script&lang=js"
export * from "./NarrationMessage.vue?vue&type=script&lang=js"

import "./NarrationMessage.vue?vue&type=style&index=0&id=c2575ef0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2575ef0"

export default script